<template>
  <div class="row">
    <div class="col-12">
      <b-carousel v-if="ListSlider.length > 0" id="carousel-fade" :interval="4000" controls style="text-shadow: 0px 0px 2px #000" fade indicators img-width="1024" img-height="480">
        <b-carousel-slide v-for="(item, index) in ListSlider" :key="index" :caption="item.title ? item.title : ''" :img-src="$cookies.get('URL') + item.filepathMainPIC + item.filenameMainPIC">
          <p v-if="item.des">{{ item.des.slice(0, 150) }}{{ item.des.length > 150 ? '...' : '' }}</p>
          <a v-if="item.filenamefile" :href="$cookies.get('URL') + item.filepathfile + item.filenamefile" target="_blank"> دانلود توضیحات بیشتر </a>
        </b-carousel-slide>
      </b-carousel>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ListSlider: [],
    }
  },
  methods: {
    GetSlider() {
      var DataAxiosGet = { Action: 'Catlog/Slider', Method: 'POST', ArryfildValue: {} }
      this.$PostData(DataAxiosGet).then((result) => {
        this.ListSlider = result.data
      })
    },
  },
  created() {
    this.GetSlider()
  },
}
</script>

<style>
/* .carousel-item {
  height: 30vh !important;
} */
</style>
